<template>
    <div class="container-fluid" >
        <div class="row">
            <div class="header-logo">
                <img :src="$img('logo.png')" />
                <svg-item class="backButton" @click.native="onBackClick" size="42" :color="'--main-color'" :icon="'volver'"></svg-item>
            </div>
            <div class="col-xs-24">
                <div class="col-container">
                    <h1 v-if="send" v-lang.emailSent> Email enviado </h1>
                    <h1 v-else v-lang.recoveryPassword> Recuperar contraseña </h1>
                    <div class="form row" v-if="send">
                        <p v-lang.recoveryIndications> Se ha enviado un email a su casilla de correo con su nueva contraseña. </p>
                    </div>
                    <div id="form" class="form row" v-else>
                        <div class="form-input-wrapper">
                            <label class="form-label" for="txt_email_recovery" v-lang.mail>Email</label>
                            <input v-jump:click.blur="'btn_recover'" class="form-input" maxlength="40" type="text" id="txt_email_recovery" ref="txt_email_recovery" v-model='email' :class="{'has-error': emailError.state }"/>
                            <span class="error" v-if="emailError.state"> {{emailError.message}} </span>
                        </div>
                        <button id="btn_recover" ref="btn_recover" class="btn btn-primary btn-shadowed-black" @click="reset"> <span v-if="!loading" v-lang.recoveryPassword> Recuperar contraseña </span> <loader :flag="loading"> </loader> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import bus from '../../services/bus-event';
import router from '../../router';
import Error from '@/services/inputError';
import Forms from '../mixins/forms';
import dialogs from '../../services/dialogs.js';

let emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export default {
    name: 'reset-password',
    data () {
        return {
            email: '',
            emailError: new Error(),
            loading: false,
            send: false
        };
    },

    computed: {
        ...mapGetters({
            isMobile: 'device/isMobile'
        })
    },

    methods: {
        ...mapActions({
            'resetPassword': 'auth/resetPassword',
            'changePassword': 'auth/changePassword'
        }),
        reset () {
            if (emailRegex.test(this.email)) {
                this.loading = true;
                this.resetPassword(this.email).then(() => {
                    this.loading = false;
                    this.send = true;
                }, (err) => {
                    if (err && err.status === 401) {
                        this.emailError.state = true;
                        this.emailError.message = this.translate('userDoesntExist');
                        this.jumpToError();
                    } else {
                        dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
                        console.error(err);
                    }
                    this.loading = false;
                });
            } else {
                this.emailError.state = true;
                this.emailError.message = this.translate('invalidMail');
                this.jumpToError();
            }
        },
        onBackClick () {
            router.back();
        }
    },
    watch: {
        email () { this.emailError.state = false; },
        password () { this.passwordError.state = false; },
        passwordConfirmation () { this.passwordError.state = false; }
    },
    mounted () {
        this.language = this.$getLang();
        bus.on('back-click', this.onBackClick);
    },
    beforeDestroy () {
        bus.off('back-click', this.onBackClick);
    },
    mixins: [Forms]
};
</script>


<style scoped>
    .header-logo {
        width: 100%;
        background-color: var(--main-light-color);
        padding: 2em 1em 1.6em 1em;
        text-align: center;
        margin-bottom: 2em;
        position: relative;
    }
    .header-logo img {
        max-width: 300px;
        width: 100%;
    }
    .col-container {
        padding: 0 .4em;
    }
    .backButton {
        position: absolute;
        top: .4em;
        left: .4em;
        cursor: pointer;
    }
    .form {
        padding: 1em;
    }
    span.error {
        display: block;
        font-size: 12px;
        margin-top: -5px;
        color: red;
        font-weight: bold;
    }
    .form-input-wrapper {
        margin-top: 0;
    }
    p {
        margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/ResetPassword.vue